import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "switch-arrows",
  "use": "switch-arrows-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"switch-arrows\"><path d=\"M32 10.667l-7.083 7.083v-5.333h-12.5v-3.5h12.5V3.583zM7.083 14.25v5.333h12.5v3.5h-12.5v5.334L0 21.333z\" fill=\"#444\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol